/**
 * List Schema of EsconderMotorista
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'

/* TODO: review generated schema */
export class ListEsconderMotoristaSchema extends Schema {
  readonly name = 'ListEsconderMotorista'

  readonly fieldSet: FieldSet<EsconderMotorista> = {
    idEsconderMotoristaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    data: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.data),
      },
    }),
  }
}
